<template>
  <div id="check" class="home">
    <el-container>   
      <div style="margin:80px 100px;width:100%;">
        <div class="">
          <div class="intro">
            <el-row>
              <el-col :span="8">
                <img src="../assets/images/jiuxingrenge.png" style="width:100%" alt="">
              </el-col>
              <el-col :span="14" :offset="2">
                <div style="margin-top:10px;font-size:14px;line-height:28px;text-align:justify;">在性格心理学中，九型人格就是一套最为实用且精确的学问，通过性格类型的觉察，你可以在最短时间内看到自己的思维模式、情绪模式以及行为模式的规律，帮助你认清自己。
"九型人格"，在英文中称为Enneagram。这是一门古老的智慧，是一门关于人格分类的学问，源自古老的苏菲教派，有着2500多年历史传承。
近年来倍受美国斯坦福大学等国际著名大学MBA学员推崇并成为现今最热门的课程之一，近十几年来已风行欧美学术界及工商界。 全球500强企业的管理阶层均有研习九型人格，并以此培训员工，建立团队，提高执行力。</div>            
              </el-col>
            </el-row>
            
          </div>
        </div>      
        <div class="content">
          <div class="qs-item" v-for="(item,index) in qs" :key="index">
            <div class="title">{{ index+1 }}、{{ item.title }}</div>
            <div v-for="(as,idx) in item.an" :key="idx" class="answer-box">
              <div :class="{'answer-item':true, 'active': answer[index] == as.t }"  :data-v="as.t" @click="select( index , as.t )">{{ idx==0?"A":"B" }}：{{ as.a }};</div>
            </div>
          </div>
          <el-button type="primary" style="width:200px;" @click="doCheck">{{ status }}</el-button>
        </div>
        <!-- 报告类型选择弹出层 -->
        <el-dialog title="选择下载类型" :visible.sync="outerVisible" :close-on-click-modal="false" :close-on-press-escape="false">
          <div style="width:100%">
            <el-row :gutter="20">
              <el-col :span="12">
                <div :class="{'cart_n':true,'cart':true,'active':downloadType == 4}" @click="handleSelect(4)">
                  <div class="title">标准版（首次免费）</div>
                  <div class="">售价￥9.8每份</div>
                </div>              
              </el-col>
              <el-col :span="12">
                <div :class="{'cart_p':true,'cart':true,'active':downloadType == 5}" @click="handleSelect(5)">
                  <div class="title">专业版</div>
                  <div class="">售价￥19.8每份</div>
                </div>
              </el-col>
            </el-row>            
          </div>
          <div slot="footer" class="dialog-footer">
            <el-button type="primary" @click="download" :loading="loading">确认付款购买</el-button>
          </div>
        </el-dialog>
        <!-- 报告类型选择弹出层 --> 
        <!-- 报告下载 -->
        <el-dialog title="下载报告" :visible.sync="innerVisible" :close-on-click-modal="false" :close-on-press-escape="false">
          <div>
            <el-row :gutter="20">
              <el-col :span="12">
                <div>
                  <a :href="url" target="_blank" download="测评结果文件.pdf">点击下载报告</a>
                </div>
              </el-col>              
            </el-row>            
          </div>
        </el-dialog>
        <!-- 报告下载 -->
      </div>
    </el-container>
  </div>
</template>
<script>
import { fetchGet,fetchPost } from '../utils/http';
import personality from '../utils/9person';
export default {
  name:'check',
  data(){
    return {
      outerVisible: false,
      innerVisible: false,
      innerHTML:{},      
      status:'提交答案',
      source:'http://www.wisechoices.cn',
      downloadType:4,
      url:'',
      loading:false,
      qs:[],
      answer:["","","","","","","","","","","","","","","","","","","","","","","","","","","","","","","","","","","","","","","","","","","","","","","","","","","","","","","","","","","","","","","","","","","","","","","","","","","","","","","","","","","","","","","","","","","","","","","","","","","","","","","","","","","","","","","","","","","","","","","","","","","","","","","","","","","","","","","","","","","","","","","","",]
    }
  },
  methods:{
    select(questionNum,answerT){
      let token = sessionStorage.getItem('token');
      if(token == undefined || token == null){
        this.$message.error('登录后才能测试，请先登录或注册用户');
        setTimeout(()=>{
          return this.$router.push('/login');
        },1000)        
      }

      //修改数组答案
      this.$set(this.answer,questionNum, answerT);
    },
    download(){
      this.loading = true;
      let _this = this;
      fetchPost('/api/home/api/downloadPERSONALITYreport',{
        downloadType:this.downloadType,answer : this.answer,source:this.source
      }).then((res)=>{
        this.loading = false;
        if(res.data.code === 10001){
          _this.$message.error(res.data.msg);
          _this.$router.push('/login');
        }
        if(res.data.code === 10002){
          _this.$message.error(res.data.msg);
          _this.$router.push('/member-center');
        }
        if(res.data.code === 0){
          return _this.$message.error(res.data.msg);        
        }
        if(res.data.code === 1){
          if(res.data.data.status == 2000){
            var newWin = window.open("","_blank");
            newWin.document.body.innerHTML = res.data.data.form;
            newWin.document.forms[0].submit();
            return;
          }
          if(res.data.data.status == undefined){
            _this.url = res.data.data;
            _this.innerVisible = true;           
          }
        }
      });
    },
    doCheck(){
      if( this.answer.includes("") ){
        return this.$message.error('还有题目未选择，请先做完所有测试题');
      }
      this.outerVisible = true;      
    },
    handleSelect(index){
      this.downloadType = index;
    },
    init(){            
      this.qs = personality;
    }
  },
  mounted(){
    this.init();    
  }
}
</script>
<style scoped>
.home{
  background-color: #f4f4f4;
  width: 100%;
}
.content{
  background-color: #ffffff;
  padding: 50px 80px;
}
.qs-item{
  margin-bottom: 30px;
}
.title{
  font-size: 14px;
  padding-bottom: 10px;
}
.answer-item{
  font-size: 14px;
  color: #777;
  margin-bottom: 4px;
  cursor: pointer;
  padding: 8px 12px;
  width: 500px;
}
.answer-box{
  margin-left: 24px;
}
.answer-item:hover{
  background-color: #05A4C2;
  color: #ffffff;
}
.active{
  background-color: #05A4C2;
  color: #ffffff;
}
.intro{
  font-size: 14px;
  text-align: justify;
  color: #888;
  line-height: 2;
  border-radius: 5px;
  background-color: #ffffff;
  padding: 30px 50px;
  margin-bottom: 20px;
}
.cart{
  width: 100%;
  height: 120px;
  background-color: #05A4C2;
  border-radius: 10px;
  text-align: center;
  color: #ffffff;
  font-size: 16px;
  font-weight: bold;
  cursor: pointer;
}
.cart .title{
  padding-top: 35px;
  font-size: 14px;
  font-weight: bold;
}
.active{
  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.6);
  border: 1px dashed #ffffff;
}
.explain{
  margin: 50px 30px 30px 30px;  
}
</style>
